import gsap from 'gsap';

class Hero {
	constructor() {
		this.hero = document.querySelector('.hero');

		if (!this.hero) {
			return;
		}

		this.heroOverlay = this.hero.querySelector('.hero__overlay');
		this.heroContainer = this.hero.querySelector('.hero__container');
		this.init();
	}
	init() {
		gsap.to(this.heroOverlay, {
			opacity: 1,
			scrollTrigger: {
				trigger: this.hero,
				start: 'top top',
				end: 'bottom bottom',
				scrub: true,
				onUpdate: (scrollTrigger) => {
					// Получаем прогресс прокрутки
					const scrollProgress = scrollTrigger.progress;
					gsap.set(this.heroContainer, {
						zIndex: scrollProgress < 0.5 ? 3 : 0,
					});
				},
			},
		});
	}
}

export default new Hero();
